import React, { lazy, Suspense } from 'react';

import Loading from '../../../../common/Loading';

const ChatsItems = lazy(() => import('.'));

export const AsyncChatItems = (props) => (
  <Suspense fallback={<Loading />}>
    <ChatsItems {...props} />
  </Suspense>
);
